/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Upcoming_InvoiceInputs */



/**
* | output |
* | --- |
* | "Upcoming invoice" |
*
* @param {Billing_Upcoming_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_upcoming_invoice = /** @type {((inputs?: Billing_Upcoming_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Upcoming_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächste Rechnung")
	return /** @type {LocalizedString} */ ("Upcoming invoice")
});